<template>
  <div>
    <div class="row">
      <div class="col-12">
        <router-link class="ml-1" to="/device-link/reports">Back to list</router-link>
      </div>
    </div>
    <div class="row" v-if="isLoading">
      <div class="col-12">
        <loading-card />
      </div>
    </div>
    <div class="row" v-else-if="deviceReport">
      <div class="col-xl-12 col-xxl-7">
        <card :title="deviceClass">
          <template v-slot:header-right>
            <download-button v-if="deviceClass == 'MacBook Report' || deviceClass == 'Chromebook Report' || deviceClass == 'Chromebook Audit and Test Report'"
              :url="downloadUrl"
              :fileName="fileName"
            >
              Certificate
            </download-button>
          </template>
          <device-link-report-table :deviceReport="deviceReport"></device-link-report-table>
        </card>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-11">
        <card title="Computer" subTitle="404 error" :isFullPage="true">
          <div class="card-body text-center">
            <p>Oops.. we could not find the device report you were looking for.</p>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingCard from '../components/Cards/LoadingCard';
import Card from '../components/Cards/Card.vue';
import DownloadButton from '../components/DownloadButton.vue';
import DeviceLinkReportTable from '../components/Tables/DeviceLinkReportTable.vue'
import { mapGetters } from 'vuex';

export default {
  name: "DeviceLinkReport",
  components: {
    LoadingCard,
    Card,
    DeviceLinkReportTable,
    DownloadButton
  },
  props: {
    id: String
  },
  data() {
    return {
      isLoading: false,
      isFetching: false,
    };
  },
  async created() {
    this.isLoading = true;
    await this.$store.dispatch('deviceReport/fetchDeviceReport', this.id);
    this.isLoading = false;
  },
  computed: {
    ...mapGetters('deviceReport', ['deviceReport']),
    deviceClass() {
      if (this.deviceReport !== undefined && this.deviceReport != null) {
        return `${this.deviceReport.report.device_class} Report`;
      }
      else {
        return "Report";
      }
    },
    fileName() {
      let serial = this.deviceReport.report.session.serial;
      if (serial !== undefined && serial != null && serial.length > 0) {
        // Assuming this.deviceReport.report.created_at is like "2023-04-20T12:53:34.047379"
        const dateTimeString = this.deviceReport.report.created_at;
        const datePart = dateTimeString.split('T')[0];
        const timePart = dateTimeString.split('T')[1].split('.')[0];
        // Format the date and time with underscores as separators
        const formattedDateTime = `${datePart}_${timePart.replace(/:/g, '')}`;
        let filename = formattedDateTime + '_' + serial;
        // Make it filesystem safe
        filename = filename.replace(/[/\\?%*:|"<>]/g, '');
        return `${filename}.pdf`;
      }
      return `certificate.pdf`;
    },
    downloadUrl() {
      return `${process.env.VUE_APP_API_URL}/device-reports/${this.id}?format=pdf`;
    }
  }
}
</script>
<style>
th {
  font-size: 1.1em !important;
}
</style>
